import { generateId } from "@msuite/utils/strings";

export const templates = {
	meeting: [
		{
			id: generateId(),
			title: "📝 Tagesordnung",
			content:
				'{"type":"doc","content":[{"type":"orderedList","attrs":{"start":1,"type":null},"content":[{"type":"listItem","content":[{"type":"paragraph","attrs":{"textAlign":null},"content":[{"type":"text","text":"TOP 1"}]}]},{"type":"listItem","content":[{"type":"paragraph","attrs":{"textAlign":null},"content":[{"type":"text","text":"TOP 2"}]}]},{"type":"listItem","content":[{"type":"paragraph","attrs":{"textAlign":null},"content":[{"type":"text","text":"TOP 3"}]}]}]}]}',
		},
		{
			id: generateId(),
			title: "✍️ TOP 1",
			content: "",
		},
		{
			id: generateId(),
			title: "✍️ TOP 2",
		},
		{
			id: generateId(),
			title: "✍️ TOP 3",
		},
		{
			id: generateId(),
			title: "🎯 Aktionspunkte",
		},
	],
	general: [
		{
			id: generateId(),
			title: "",
		},
	],
	"call-request": [
		{
			id: generateId(),
			title: "",
		},
	],
	negotiation: [
		{
			id: generateId(),
			title: "",
		},
	],
} as const;
